<template>
    <p class="card-text"><slot></slot></p>  
</template>
